import React from "react";

const Progressbar = ({
  currentStep = "Pending"
}) => {

  const allSteps = [

    "Pending",
    "Approved",
    "Pending for Court Order Review",
    "Court Order Approved",
    "Repo Initiated",
    "Repo Checklist Submitted",
    "Inspection Scheduled",
    "Inventory Created",
    "Yard Placement Pending",
    "Vehicle Yarded",
    "Ready For Listing Approval",
    "Listing Approved",
    "Live For Auction",
    "Auction Completed",
    "Sold"

  ];

  const currentIndex =
    allSteps.indexOf(currentStep);

  const isLastCompleted =
    currentIndex === allSteps.length - 1;

  return (

    <div
      style={{
        width: "100%",
        overflowX: "auto",
        padding: "8px 0px 2px",
        background: "#f8fafc"
      }}
    >

      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          minWidth: "1500px",
          position: "relative",
          padding: "10px 5px 18px"
        }}
      >

        {/* MAIN CONNECTED LINE */}

        <div
          style={{
            position: "absolute",
            top: "32px",
            left: "70px",
            right: "70px",
            height: "6px",
            borderRadius: "20px",
            background: "#dbe2ea",
            zIndex: 1,
            overflow: "hidden"
          }}
        >

          {/* ACTIVE GREEN FLOW */}

          <div
            style={{
              width: `${
                (
                  currentIndex /
                  (allSteps.length - 1)
                ) * 100
              }%`,

              height: "100%",

              background:
                "linear-gradient(90deg,#16a34a,#22c55e)",

              borderRadius: "20px",

              transition: "all 0.5s ease",

              position: "relative"
            }}
          >

            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(90deg,transparent,rgba(255,255,255,0.7),transparent)",
                animation: "flow 2s linear infinite"
              }}
            />

          </div>

        </div>

        {/* STEPS */}

        {allSteps.map((step, index) => {

          const completed =
            index <= currentIndex;

          const active =
            index === currentIndex + 1;

          return (

            <div
              key={step}
              style={{
                width: "105px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                zIndex: 2,
                flexShrink: 0
              }}
            >

              {/* CIRCLE */}

              <div
                style={{

                  width: "46px",
                  height: "46px",

                  borderRadius: "50%",

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                  fontWeight: "700",
                  fontSize: "15px",

                  color: "#fff",

                  background:
                    completed ||
                    (
                      isLastCompleted &&
                      index === currentIndex
                    )
                      ? "linear-gradient(135deg,#16a34a,#22c55e)"
                      : active
                      ? "linear-gradient(135deg,#f59e0b,#fbbf24)"
                      : "#cbd5e1",

                  border:
                    active
                      ? "4px solid rgba(245,158,11,0.25)"
                      : "4px solid #fff",

                  animation:
                    active
                      ? "pulse 1.4s infinite"
                      : "none",

                  boxShadow:
                    active
                      ? "0 0 25px rgba(245,158,11,0.45)"
                      : completed
                      ? "0 0 18px rgba(22,163,74,0.28)"
                      : "none",

                  transition: "all 0.35s ease"
                }}
              >

                {
                  completed ||
                  (
                    isLastCompleted &&
                    index === currentIndex
                  )
                    ? "✓"
                    : index + 1
                }

              </div>

              {/* TITLE */}

              <div
                style={{
                  marginTop: "14px",
                  textAlign: "center",

                  fontSize: "10px",
                  fontWeight: "700",
                  lineHeight: "1.4",

                  color:
                    completed || active || index === currentIndex
                      ? "#0f172a"
                      : "#94a3b8",

                  minHeight: "34px",

                  padding: "0 8px"
                }}
              >
                {step}
              </div>

              {/* STATUS */}

              <div
                style={{
                  marginTop: "5px",
                  fontSize: "10px",
                  textAlign: "center",

                  color:
                    completed
                      ? "#16a34a"
                      : index === currentIndex
                      ? "#f59e0b"
                      : "#94a3b8",

                  fontWeight:
                    index === currentIndex
                      ? "700"
                      : "500"
                }}
              >

                {
                  completed
                    ? "Completed"
                    : index === currentIndex
                    ? "Current Step"
                    : "Waiting"
                }

              </div>

            </div>

          );

        })}

      </div>

      <style>
        {`

          @keyframes pulse {

            0% {
              transform: scale(1);
            }

            50% {
              transform: scale(1.08);
            }

            100% {
              transform: scale(1);
            }

          }

          @keyframes flow {

            0% {
              transform: translateX(-120%);
            }

            100% {
              transform: translateX(220%);
            }

          }

          ::-webkit-scrollbar {
            height: 8px;
          }

          ::-webkit-scrollbar-thumb {
            background: rgba(148,163,184,0.12);
            border-radius: 20px;
          }

        `}
      </style>

    </div>

  );

};

export default Progressbar;